import { Payload } from 'Models/UI/Payload';

export class PayloadOverview implements Payload {
    acceptRemarks : boolean;
    subscribeToNewsletter : boolean;
    acceptTermsConditionAndDataPolicy : boolean;
}